import React, { useEffect, useId, useState } from "react";
import { Link } from "react-router-dom";
import "./MenuItems.css";
import AcademicLevelService from "../../service/academicLevelService";
import AcademicStageMenu from "./AcademicStageMenu";

const MenuItems = ({ mobileMenu, onNavigate }) => {
  const [classesOpen, setClassesOpen] = useState(false);
  const submenuId = useId();
  const [stages, setStages] = useState(null);
  const [activeStage, setActiveStage] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!classesOpen || stages !== null) return;
    const controller = new AbortController();
    setError(false);
    AcademicLevelService.getAcademicStages({ signal: controller.signal }).then((result) => {
      if (controller.signal.aborted) return;
      if (result.success && Array.isArray(result.data)) setStages(result.data);
      else setError(true);
    });
    return () => controller.abort();
  }, [classesOpen, stages, attempt]);

  const navigate = () => {
    setClassesOpen(false);
    onNavigate?.();
  };

  return (
    <ul className={`education-menu${mobileMenu ? " education-menu-mobile" : ""}`}>
      <li><Link to="/" onClick={navigate}>Accueil</Link></li>
      <li
        className="education-classes"
        onBlur={(event) => {
          if (!event.currentTarget.contains(event.relatedTarget)) setClassesOpen(false);
        }}
        onKeyDown={(event) => {
          if (event.key === "Escape") {
            setClassesOpen(false);
            event.currentTarget.querySelector("button").focus();
          }
        }}
      >
        <button
          type="button"
          className="education-classes-toggle"
          aria-expanded={classesOpen}
          aria-controls={submenuId}
          onClick={() => setClassesOpen(!classesOpen)}
        >
          Classes <i className="fal fa-angle-down" aria-hidden="true" />
        </button>
        <ul id={submenuId} className="education-levels" hidden={!classesOpen}>
          {error ? <li><p role="alert">Impossible de charger les cycles.</p><button type="button" onClick={() => setAttempt(value => value + 1)}>Réessayer</button></li>
            : stages === null ? <li role="status">Chargement…</li>
            : stages.length === 0 ? <li>Aucun cycle disponible</li>
            : stages.map(stage => <AcademicStageMenu key={stage.id} stage={stage} open={classesOpen && activeStage === stage.id} onOpen={() => setActiveStage(stage.id)} onNavigate={navigate} />)}
        </ul>
      </li>
      <li><Link to="/course-1" onClick={navigate}>Cours</Link></li>
      {mobileMenu && <li><Link to="/signin" onClick={navigate}>Se connecter</Link></li>}
    </ul>
  );
};

export default MenuItems;
